


class SetupModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }

  async uploadClientAccountFile(file,clientAccountFileConfig,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().uploadClientAccountFile(file,clientAccountFileConfig,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }

  async rebootCommandSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootCommandSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }

  async rebootConfigurationSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootConfigurationSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }
  
  async rebootCryptoSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootCryptoSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }
  
  async rebootDeviceSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootDeviceSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  } 
    
  async rebootStaffUserHandlerSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootStaffUserHandlerSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }
  
  async rebootMerchantHandlerSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootMerchantHandlerSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }         
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }
    
  async rebootClientAccountHandlerSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootClientAccountHandlerSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }  

  async rebootEcosystemHandlerSystem(_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().rebootEcosystemHandlerSystem(accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }     
  }   

}


export default SetupModuleLogic;